import React from 'react';
import { IllustrationProps } from '../../../../../types/Common';
import useToggleIllustrationColors from '../../hooks/useToggleIllustrationColors';

const IllustrationGardener: React.FC<
  React.PropsWithChildren<IllustrationProps>
> = ({ isActive = false, ...otherProps }) => {
  const colors = useToggleIllustrationColors(isActive);
  return (
    <svg
      width="356"
      height="228"
      viewBox="0 0 356 228"
      fill="none"
      {...otherProps}
    >
      <mask
        id="mask0_4222_10772"
        style={{ maskType: 'alpha' }}
        width="356"
        height="229"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#C0C2C9" d="M0 .998h356v228H0v-228z"></path>
      </mask>
      <g mask="url(#mask0_4222_10772)">
        <path
          fill={colors.primary[50]}
          d="M337 161.998c0 88.366-71.634 160-160 160s-160-71.634-160-160c0-88.365 71.634-160 160-160s160 71.634 160 160z"
        ></path>
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M146.523 82.86v-7.57h23.799a3.998 3.998 0 003.292-1.729l15.946-23.105A8 8 0 01196.144 47h22.098c26.938 0 54.96 24.568 57.575 35.86h.199c0 .255-.018.52-.054.796.036.276.054.541.054.797h-.199c-2.615 11.291-30.637 35.859-57.575 35.859h-22.098a8 8 0 01-6.584-3.455l-15.946-23.106a3.998 3.998 0 00-3.292-1.728h-23.799V82.86z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[500]}
          d="M146.523 75.29v-2a2 2 0 00-2 2h2zm27.091-1.729l-1.646-1.136 1.646 1.136zm15.946-23.105l-1.646-1.136 1.646 1.136zm86.257 32.403l-1.948.452a2 2 0 001.948 1.548v-2zm.199 0h2a2 2 0 00-2-2v2zm-.054.797l-1.983-.255c-.022.17-.022.341 0 .51l1.983-.255zm.054.797v2a2 2 0 002-2h-2zm-.199 0v-2a2 2 0 00-1.948 1.549l1.948.451zm-86.257 32.404l-1.646 1.136 1.646-1.136zm-15.946-23.106l-1.646 1.136 1.646-1.136zm-27.091-1.728h-2a2 2 0 002 2v-2zm-2-16.734v7.57h4v-7.57h-4zm25.799-2h-23.799v4h23.799v-4zm1.646-.864a1.999 1.999 0 01-1.646.864v4a6 6 0 004.938-2.592l-3.292-2.272zm15.946-23.105l-15.946 23.105 3.292 2.272 15.946-23.105-3.292-2.272zm8.23-4.32a10 10 0 00-8.23 4.32l3.292 2.272A6 6 0 01196.144 49v-4zm22.098 0h-22.098v4h22.098v-4zm59.524 37.408c-.768-3.313-3.277-7.27-6.757-11.235-3.531-4.022-8.241-8.255-13.705-12.111C246.416 51.375 232.275 45 218.242 45v4c12.906 0 26.245 5.91 36.756 13.33 5.236 3.696 9.705 7.722 13.005 11.482 3.351 3.818 5.326 7.166 5.866 9.499l3.897-.903zm-1.949 2.451h.199v-4h-.199v4zm-1.801-2c0 .163-.012.343-.037.542l3.967.51c.045-.351.07-.703.07-1.052h-4zm4 1.594c0-.349-.025-.7-.07-1.052l-3.967.51c.025.2.037.38.037.542h4zm-2.199 2h.199v-4h-.199v4zm-1.948-2.451c-.54 2.333-2.515 5.68-5.866 9.498-3.3 3.76-7.769 7.787-13.005 11.483-10.511 7.42-23.85 13.329-36.756 13.329v4c14.033 0 28.174-6.374 39.062-14.061 5.464-3.857 10.174-8.09 13.705-12.112 3.48-3.964 5.989-7.922 6.757-11.235l-3.897-.902zm-55.627 34.31h-22.098v4h22.098v-4zm-22.098 0a5.999 5.999 0 01-4.938-2.591l-3.292 2.272a10 10 0 008.23 4.319v-4zm-4.938-2.591L175.26 92.615l-3.292 2.272 15.946 23.106 3.292-2.272zM175.26 92.615a6 6 0 00-4.938-2.592v4c.658 0 1.273.323 1.646.864l3.292-2.272zm-4.938-2.592h-23.799v4h23.799v-4zm-21.799 2v-7.57h-4v7.57h4zm0-7.57V82.86h-4v1.594h4z"
        ></path>
        <path
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
          d="M78 83.258c0-6.597 5.348-11.945 11.945-11.945h60.93a6 6 0 016 6v11.89a6 6 0 01-6 6h-60.93C83.348 95.203 78 89.855 78 83.258z"
        ></path>
        <mask
          id="mask1_4222_10772"
          style={{ maskType: 'alpha' }}
          width="83"
          height="29"
          x="76"
          y="69"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#fff"
            stroke={colors.primary[500]}
            strokeWidth="4"
            d="M78 83.258c0-6.597 5.348-11.945 11.945-11.945h60.93a6 6 0 016 6v11.89a6 6 0 01-6 6h-60.93C83.348 95.203 78 89.855 78 83.258z"
          ></path>
        </mask>
        <g
          stroke={colors.primary[500]}
          strokeWidth="4"
          mask="url(#mask1_4222_10772)"
        >
          <path
            fill={colors.primary[100]}
            d="M68.438 62.547H139.344V103.172H68.438z"
          ></path>
          <path d="M78 83.258c0-6.597 5.348-11.945 11.945-11.945h60.93a6 6 0 016 6v11.89a6 6 0 01-6 6h-60.93C83.348 95.203 78 89.855 78 83.258z"></path>
        </g>
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M210.672 164.938v-7.172h-27.891l-19.125-27.891h-66.14c-6.611 0-15.141 7.57-15.141 7.57s8.663 6.774 15.14 6.774H152.5a7.172 7.172 0 110 14.343H97.516c-5.636 0-12.667 4.924-14.618 6.376h-.523s.09.071.258.199c-.168.128-.258.199-.258.199h.523c1.951 1.452 8.982 6.375 14.618 6.375H152.5a7.172 7.172 0 110 14.344H97.516c-6.478 0-15.141 6.773-15.141 6.773s8.53 7.57 15.14 7.57h66.141l19.125-27.89h27.891V164.938z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[500]}
          d="M210.672 157.766h2a2 2 0 00-2-2v2zm-27.891 0l-1.649 1.131a2 2 0 001.649.869v-2zm-19.125-27.891l1.65-1.131a2 2 0 00-1.65-.869v2zm-81.281 7.57l-1.328-1.496a2 2 0 00.096 3.072l1.232-1.576zm.523 27.493v2a2 2 0 001.194-.396l-1.194-1.604zm-.523 0v-2a2 2 0 00-1.244 3.566l1.244-1.566zm.258.199l1.21 1.592a2 2 0 000-3.184l-1.21 1.592zm-.258.199l-1.244-1.566a2 2 0 001.244 3.566v-2zm.523 0l1.194-1.605a2.005 2.005 0 00-1.194-.395v2zm-.523 27.492l-1.232-1.575a1.999 1.999 0 00-.096 3.071l1.328-1.496zm81.281 7.57v2a2 2 0 001.65-.869l-1.65-1.131zm19.125-27.89v-2a2 2 0 00-1.649.869l1.649 1.131zm27.891 0v2a2 2 0 002-2h-2zm-2-14.742v7.172h4v-7.172h-4zm-25.891 2h27.891v-4h-27.891v4zm-20.774-28.76l19.125 27.891 3.299-2.262-19.125-27.891-3.299 2.262zm-64.491.869h66.14v-4h-66.14v4zm-15.141 5.57c1.328 1.496 1.327 1.496 1.327 1.497l.002-.002a.097.097 0 01.014-.012l.063-.055a38.841 38.841 0 011.266-1.038 45.042 45.042 0 013.497-2.49c2.926-1.872 6.287-3.47 8.972-3.47v-4c-3.926 0-8.136 2.187-11.127 4.1a49.04 49.04 0 00-4.922 3.614 31.73 31.73 0 00-.386.331l-.023.02a.042.042 0 00-.007.006l-.002.002v.001c-.001 0-.002 0 1.326 1.496zm15.14 4.774c-2.678 0-6.07-1.452-9.01-3.125a47.27 47.27 0 01-4.553-2.964 19.323 19.323 0 01-.265-.199l-.064-.049-.014-.011-.003-.002-1.231 1.576-1.231 1.576v.001l.003.002.007.005a.336.336 0 00.023.018l.084.065.307.23a50.833 50.833 0 004.96 3.228c3.01 1.714 7.188 3.649 10.988 3.649v-4zm54.985 0H97.516v4H152.5v-4zm9.172 9.172a9.172 9.172 0 00-9.172-9.172v4a5.172 5.172 0 015.172 5.172h4zm-9.172 9.171a9.172 9.172 0 009.172-9.171h-4a5.172 5.172 0 01-5.172 5.171v4zm-54.984 0H152.5v-4H97.516v4zm-13.424 5.98a44.12 44.12 0 015.658-3.563c2.632-1.374 5.445-2.417 7.766-2.417v-4c-3.315 0-6.836 1.419-9.616 2.87a48.2 48.2 0 00-6.196 3.901l2.388 3.209zm-1.194-3.604h-.523v4h.523v-4zm-.523 2l-1.244 1.566.001.001.002.001.005.004.017.013.057.045.21.161 2.42-3.184-.174-.135a.9.9 0 01-.041-.032l-.009-.006-.001-.001-1.243 1.567zm0 .398l1.244 1.566v.001h-.001l.001-.001.009-.007.04-.032.176-.134-2.421-3.184-.21.161-.057.044a.234.234 0 01-.017.013l-.005.004-.002.002v.001l1.243 1.566zm.523-2h-.523v4h.523v-4zm-1.194 3.604c1.02.759 3.36 2.421 6.196 3.901 2.78 1.451 6.3 2.87 9.616 2.87v-4c-2.321 0-5.134-1.043-7.766-2.416a43.984 43.984 0 01-5.658-3.564l-2.388 3.209zm15.812 6.771H152.5v-4H97.516v4zm54.984 0a5.172 5.172 0 015.172 5.172h4a9.172 9.172 0 00-9.172-9.172v4zm5.172 5.172a5.173 5.173 0 01-5.172 5.172v4a9.173 9.173 0 009.172-9.172h-4zm-5.172 5.172H97.516v4H152.5v-4zm-54.984 0c-3.8 0-7.978 1.935-10.989 3.648a51.122 51.122 0 00-4.96 3.228l-.306.231-.084.064a.39.39 0 01-.03.024l-.002.001-.001.001 1.231 1.576 1.231 1.576.003-.002.014-.011.064-.049.265-.199a46.946 46.946 0 014.554-2.963c2.94-1.674 6.331-3.125 9.01-3.125v-4zm-15.141 8.773c-1.328 1.496-1.327 1.496-1.327 1.497h.001l.002.002a48.771 48.771 0 005.337 3.971c2.992 1.914 7.202 4.1 11.128 4.1v-4c-2.685 0-6.046-1.598-8.972-3.47a44.796 44.796 0 01-4.502-3.305c-.116-.097-.204-.173-.261-.222l-.063-.055a.268.268 0 00-.014-.012l-.002-.002-1.327 1.496zm15.14 9.57h66.141v-4h-66.14v4zm67.791-.869l19.125-27.89-3.299-2.262-19.125 27.89 3.299 2.262zm17.475-27.021h27.891v-4h-27.891v4zm29.891-2v-7.172h-4v7.172h4zm0-7.172v-.398h-4v.398h4z"
        ></path>
        <path
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
          d="M278 165.336c0-6.597-5.348-11.945-11.945-11.945h-60.93a6 6 0 00-6 6v11.89a6 6 0 006 6h60.93c6.597 0 11.945-5.348 11.945-11.945z"
        ></path>
        <mask
          id="mask2_4222_10772"
          style={{ maskType: 'alpha' }}
          width="83"
          height="29"
          x="197"
          y="151"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#fff"
            stroke={colors.primary[500]}
            strokeWidth="4"
            d="M278 165.336c0-6.597-5.348-11.945-11.945-11.945h-60.93a6 6 0 00-6 6v11.89a6 6 0 006 6h60.93c6.597 0 11.945-5.348 11.945-11.945z"
          ></path>
        </mask>
        <g
          stroke={colors.primary[500]}
          strokeWidth="4"
          mask="url(#mask2_4222_10772)"
        >
          <path
            fill={colors.primary[100]}
            d="M-2 2H68.906V42.625H-2z"
            transform="matrix(-1 0 0 1 285.562 142.625)"
          ></path>
          <path d="M278 165.336c0-6.597-5.348-11.945-11.945-11.945h-60.93a6 6 0 00-6 6v11.89a6 6 0 006 6h60.93c6.597 0 11.945-5.348 11.945-11.945z"></path>
        </g>
        <path
          fill={colors.primary[500]}
          fillRule="evenodd"
          d="M20 226.998a2 2 0 012-2h310a2 2 0 110 4H22a2 2 0 01-2-2z"
          clipRule="evenodd"
        ></path>
      </g>
    </svg>
  );
};

export default IllustrationGardener;
